import Input from "@/components/frontend/ui/form/inputs/input";
import { type FormPhoneBlock as FormPhoneBlockT } from "@/payload-types";

type FormPhoneBlockProps = FormPhoneBlockT & {
	containerClassName?: string;
	fieldName?: string;
	fieldValue?: unknown;
	fieldError?: string;
	onFieldChange?: (value: unknown) => void;
	onFieldBlur?: () => void;
};

export const FormPhoneBlock: React.FC<FormPhoneBlockProps> = ({
	content,
	settings,
	containerClassName,
	fieldName,
	fieldValue,
	fieldError,
	onFieldChange,
	onFieldBlur,
}) => {
	return (
		<Input
			name={fieldName}
			type="tel"
			value={typeof fieldValue === "string" ? fieldValue : ""}
			onChange={(event) => onFieldChange?.(event.target.value)}
			onBlur={onFieldBlur}
			autoComplete={settings?.autocomplete ?? undefined}
			placeholder={content.placeholder}
			label={content.label}
			hideLabel={settings?.hideLabel ?? undefined}
			description={content.description}
			minLength={7}
			maxLength={15}
			error={fieldError}
			required={content.required ?? false}
			containerClassName={containerClassName}
		/>
	);
};
